import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import Carousel from '../../carousel/Carousel';
import {
  MEDIA_PACKAGE_CHART_LIST,
  LENGHT_OF_CAROUSEL_HEADER_LABEL,
} from '../../../constants';
import SalesCatalystMediaPackageBarChart from '../SalesCatalystCharts/SalesCatalystMediaPackageBarChart';
import { nthOccurrence, exportFileTitle } from '../../../util/CommonUtils';
import salesExport from '../../../images/export-icon_white.png';
import MediaBarChartPdf from './MediaBarChartPdf';
import { download } from '../../../util/SalesCatalystUtils';

const carouselIndicatorInfo = [
  { label: 'Target Market' },
  { label: 'Overlap Persona' },
  { label: 'Overlap Persona + Brand' },
  { label: 'Target Market + Brand' },
];


class SalesCatalystMediaPackageImageBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setSelectedSlideIndex: 0,
      headerLabelTooltip: '',
      chartSortInfo: {},
    };
  }


  setSelectedSlideIndex = index => {
    this.setState({ setSelectedSlideIndex: index });
    return this.state.setSelectedSlideIndex;
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.chartSortInfo !== nextProps.chartSortInfo) {
      this.setState({
        chartSortInfo: nextProps.chartSortInfo,
      });

      if (this.props.graphData) {
        this.setState({
          graphData: nextProps.graphData,
        });
      }
    }
  }


  setHeaderLabel = (index, pdfHeaderFlag) => {
    const join = ' / ';
    const overlap = ' OVERLAP PERSONA ';
    const headerObj = {
      label: '',
      headerLabelTooltip: '',
    };
    // let tooltip header Label = '';
    const entity = this.props.entity[0] !== undefined ? this.props.entity[0].label : '';
    const target = this.props.targetMarket[0] !== undefined ? this.props.targetMarket[0].label : '';
    const brand = this.props.brand[0] !== undefined ? this.props.brand[0].label : 'BRAND *(Required)';

    const targetLabel = this.props.targetMarket[0] !== undefined ? this.props.targetMarket[0].label.substring(0, this.getIndexOfTargetHeader(this.props.targetMarket[0].label)) : '';
    const entityLabel = this.props.entity[0] !== undefined ? this.props.entity[0].label.substring(0, this.getIndexOfTargetHeader(this.props.entity[0].label)) : '';
    const brandLabel = (this.props.brand[0] !== undefined) ? this.props.brand[0].label.substring(0, this.getIndexOfTargetHeader(this.props.brand[0].label)) : 'BRAND *(Required)';

    if (pdfHeaderFlag === true) {
      if (index === 0) {
        headerObj.label = targetLabel;
      } else if (index === 1) {
        headerObj.label = targetLabel + join + entityLabel + overlap;
      } else if (index === 2) {
        headerObj.label = targetLabel + join + entityLabel + join + brandLabel;
      } else if (index === 3) {
        headerObj.label = targetLabel + join + brandLabel + overlap;
      }
    }
    if (pdfHeaderFlag === false) {
      if (this.state.setSelectedSlideIndex === 0) {
        headerObj.headerLabelTooltip = target;
        headerObj.label = targetLabel;
      } else if (this.state.setSelectedSlideIndex === 1) {
        headerObj.label = targetLabel + join + entityLabel + overlap;
        headerObj.headerLabelTooltip = target + join + entity;
      } else if (this.state.setSelectedSlideIndex === 2) {
        headerObj.label = targetLabel + join + entityLabel + join + brandLabel;
        headerObj.headerLabelTooltip = target + join + entity + join + brand;
      } else if (this.state.setSelectedSlideIndex === 3) {
        headerObj.label = targetLabel + join + brandLabel + overlap;
        headerObj.headerLabelTooltip = target + join + brand + overlap;
      }
    }
    return headerObj;
  }


  getIndexOfTargetHeader = label => {
    let lenghtOfLabel = LENGHT_OF_CAROUSEL_HEADER_LABEL;
    const nthOccurrenceIndexOfEntity = nthOccurrence(label, ')', 1);
    if (
      nthOccurrenceIndexOfEntity < lenghtOfLabel &&
      nthOccurrenceIndexOfEntity !== -1 &&
      nthOccurrenceIndexOfEntity !== 'undefined'
    ) {
      lenghtOfLabel = nthOccurrenceIndexOfEntity + 1;
    }
    return lenghtOfLabel;
  };


  // generated html format for pdf...
  downloadMediaPdf = () => {
    // const currentDate = moment().format('YYYYMMDD');
    // const currentTime = new moment().format('HHmmss');

    // const pdfName = 'Media_Bar_Chart';
    // const pdfFileNameFormat = `${pdfName}_${currentDate}_${currentTime}`;
    const pdfFileName = `${exportFileTitle('SalesCatalyst_Media_Bar_Chart')}.pdf`;
    // this.setState({ downloadState: true });
    const mediaBarChartHtml = document.getElementById('downloadSlide');
    if (mediaBarChartHtml !== null) {
      const cloneMediaBarChartHtml = mediaBarChartHtml.cloneNode(true);
      cloneMediaBarChartHtml.setAttribute('class', 'salesCatalystExport');
      const attitudePageBreak = document.createElement('div');
      attitudePageBreak.setAttribute('class', 'html2pdf__page-break');
      cloneMediaBarChartHtml.append(attitudePageBreak);
      download(pdfFileName, cloneMediaBarChartHtml);
    }
  }

  render() {
    const carouselSlidesData = { slideName: SalesCatalystMediaPackageBarChart };
    let headerObj = {};
    if (this.props.entity[0] !== undefined && this.props.targetMarket[0] !== undefined) {
      headerObj = this.setHeaderLabel(this.state.setSelectedSlideIndex, false);
    }

    return (
      <div>
        {!_.isEmpty(this.props.targetEntityOverlap) &&
          <div className="row scMediaPackage-Landing-BlockSection pdf-charts">
              <MediaBarChartPdf
                graphPdfHeader={this.setHeaderLabel}
                chartSortInfo={this.props.chartSortInfo}
              />
            <div className="large-12 medium-12 small-12 columns scMediaPackage-imageBlock-header">
              <div className="scMediaPackage-imageBlock-header-heading" title={headerObj.headerLabelTooltip}>{headerObj.label}</div>
              <div className="row position-relative">
                <span
                  className="salesExport"
                >
                  <img
                    className="move-icon"
                    alt="moveIcon"
                    onClick={this.downloadMediaPdf}
                    src={salesExport}
                  />
                </span>
                <Carousel
                  slide={carouselSlidesData}
                  setSelectedSlideIndex={this.setSelectedSlideIndex}
                  flag={this.props.dataOnScreenTarget}
                  indicatorInfo={carouselIndicatorInfo} slideCount={MEDIA_PACKAGE_CHART_LIST}
                  studyLabel={this.props.studyLabel}
                />
              </div>
            </div>
            <div className="row fullWidth">&nbsp;
            </div>
          </div>
        }
      </div>

    );
  }
}

SalesCatalystMediaPackageImageBlock.propTypes = {
  download: PropTypes.func,
  studyLabel: PropTypes.string,
};


function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    dataOnScreenTarget: state.salesCatalyst.dataOnScreen,
    entity: state.salesCatalyst.dataSelection.entity,
    targetMarket: state.salesCatalyst.dataSelection.targetMarket,
    brand: state.salesCatalyst.dataSelection.brand,
    targetEntityOverlap: state.salesCatalyst.dataSelection.targetEntityOverlap,
    sortInfo: state.salesCatalyst.chartSortInfo,
    chartSortInfo: state.salesCatalyst.chartSortInfo,
    graphData: state.salesCatalyst.graphData,
  };
}


export default connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true },
)(SalesCatalystMediaPackageImageBlock);
